import { render, staticRenderFns } from "./ImgViewer.vue?vue&type=template&id=5462e018&scoped=true&"
import script from "./ImgViewer.vue?vue&type=script&lang=js&"
export * from "./ImgViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImgViewer.vue?vue&type=style&index=0&id=5462e018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462e018",
  null
  
)

export default component.exports